<script setup lang="ts">
import { ESection } from '@/components/base/Email'
import EmailBlockWrapper from './EmailBlockWrapper.vue'
import EmailSocialToolbar from './EmailSocialToolbar.vue'
import SocialNetworkIcon from './SocialNetworkIcon.vue'
import type { SocialBlock } from '../../types'

const { t } = useI18n()

defineProps<{
  block: SocialBlock
  isSelected: boolean
  colorPresets?: { color: string; label: string }[]
}>()

const emit = defineEmits<{
  (e: 'select'): void
  (e: 'update:block', block: SocialBlock): void
}>()

const justifyMap: Record<string, string> = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
}
</script>

<template>
  <EmailBlockWrapper
    :is-selected="isSelected"
    :label="t('pages.email.emailTemplateCreatePage.blockSocial')"
    cursor="pointer"
    :block-background-color="block.blockBackgroundColor"
    @select="emit('select')"
  >
    <ESection :style="{ padding: '20px 0' }">
      <div
        :style="{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '8px',
          justifyContent: justifyMap[block.align] ?? 'center',
          padding: '0 40px'
        }"
      >
        <a
          v-for="link in block.links"
          :key="link.id"
          :href="link.url || '#'"
          target="_blank"
          rel="noopener noreferrer"
          style="display: inline-flex; text-decoration: none"
          @click.prevent
        >
          <SocialNetworkIcon
            :network="link.network"
            :set="block.iconSet"
            :size="block.iconSize"
            :icon-style="block.iconStyle"
          />
        </a>
      </div>
    </ESection>
  </EmailBlockWrapper>

  <EmailSocialToolbar
    v-if="isSelected"
    :block="block"
    :color-presets="colorPresets"
    @update:block="emit('update:block', $event)"
  />
</template>
